<script lang="ts">
  import { AuthLayout } from '@bruce/components'
  import type { LayoutData } from './$types'
  import { utils } from '$lib/utils'
  import { page } from '$app/stores'

  export let data: LayoutData
  $: ({ storedTheme } = data)
  $: localeRoute = utils.getRoute($page.params.lang)

  $: src =
    storedTheme === 'dark'
      ? '/images/bruce-studios-logo-white.svg'
      : '/images/bruce-studios-logo-black.svg'
</script>

<AuthLayout
  {src}
  {storedTheme}
  href={localeRoute('/')}
  fullWidth={$page.url.pathname.includes('/confirmation/gift-card')}
>
  <slot />
</AuthLayout>
